<template>
  <div class="card mgt-20px">
    <header class="header-card">
      <p>{{ $t('general.informationGeneral')}}</p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column is-12">
          <div class="columns is-multiline">
            <b-field
              :label="$t('editBonExpedition.dateExpedition')"
              class="column is-6 obligatoire is-marginless">
              <b-datepicker
                v-model="bonExpedition.dateBonExpedition"
                position="is-bottom-right"
                icon="calendar-today"
                nearby-selectable-month-days
                show-week-number editable>
              </b-datepicker>
            </b-field>
            <b-field
              :label="$t('editBonExpedition.nomDestination')"
              class="column is-6 obligatoire is-marginless">
              <b-autocomplete
                v-model="contactDestination"
                @input="getContactsDebounce"
                @select="actionContactSelect"
                :placeholder="$t('editBonExpedition.nomDestination')"
                :data="contacts"
                :loading="isFetchingContact"
                field="nomPrenom"
                icon="magnify"
                open-on-focus>
                <template #empty>
                  {{$t(`general.autocomplete.${!isFetchingContact ? 'noRslt' : 'search'}`)}}
                </template>
              </b-autocomplete>
            </b-field>
            <b-field
              :label="$t('editBonExpedition.nombreElementColis')"
              class="column is-6 obligatoire is-marginless">
              <b-input
                v-model.number="bonExpedition.nombreElementColis"
                :use-html5-validation="false"
                type="number" min="0" step="0.00001"/>
            </b-field>
            <b-field
              :label="$t('editBonExpedition.poidsParColis')"
              class="column is-6 obligatoire is-marginless">
              <b-input
                v-model.number="bonExpedition.poidsParColis"
                :use-html5-validation="false"
                type="number" min="0" step="0.00001"/>
            </b-field>
          </div>
        </div>
        <b-field
          :label="$t('editBonExpedition.adresseExpedition')"
          class="column is-12 obligatoire is-marginless">
          <adresse
            :adresse="bonExpedition.adresseExpedition"
            :tableName="constantes.TIERS"
            adresseName="adresseExpedition"/>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import { createNamespacedHelpers } from 'vuex';
import { getAllWithTiers as getAllContactByTiers } from '@/api/contacts';
import Adresse from '@/components/general/adresse';
import getContactFullName from '@/services/contact/contactHelper';
import messageErreur from '@/services/general/messageErreur';
import formatDate from '@/services/general/formatDate';
import { TIERS } from '@/configuration/ville/villeConf';
import { TIERS_TYPE_CLIENT } from '@/configuration/tiers/tiersConf';

const Societe = createNamespacedHelpers('societe');

export default {
  name: 'informationsGenerales',
  props: {
    bonExpedition: {
      type: Object,
      required: true,
    },
  },
  components: {
    Adresse,
  },
  data() {
    return {
      contacts: [],
      contactReceveurs: [],
      contactDestination: null,
      isFetchingContact: false,
      constantes: {
        TIERS,
      },
      func: {
        formatDate,
      },
    };
  },
  computed: {
    ...Societe.mapGetters({
      societeActive: 'societeActive',
    }),
  },
  methods: {
    actionContactSelect(opt) {
      this.contactDestination = opt?.nomPrenom || null;
      this.bonExpedition.contactDestinataireId = opt?.id || null;
      this.bonExpedition.nomContactDestinataire = opt?.nom || null;
      this.bonExpedition.emailContactDestinataire = opt?.email || null;
      this.bonExpedition.prenomContactDestinataire = opt?.prenom || null;
      this.bonExpedition.numTelephoneContactDestinataire = opt?.telephone || null;
    },
    getContactsDebounce: debounce(async function getContacts(search) {
      this.isFetchingContact = true;
      this.contacts = [];
      const query = {
        auto: search,
        archive: false,
        type: TIERS_TYPE_CLIENT,
        societeId: this.societeActive.id,
        tiersId: [this.bonExpedition.clientId],
      };
      try {
        const contacts = (await getAllContactByTiers({ query })).data.result.items.map(item => ({
          ...item,
          nomPrenom: getContactFullName(item),
        }));
        this.contacts = contacts;
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        this.isFetchingContact = false;
      }
    }, 300),
  },
  mounted() {
    this.contactDestination = [
      this.bonExpedition.prenomContactDestinataire,
      this.bonExpedition.nomContactDestinataire,
    ].filter(Boolean).join(' ');
  },
};
</script>
